const ROOT = 'VIEW_RATE_ENGINE_';

const actions = {
  LOAD_ENGINE_REQUEST: `${ROOT}LOAD_ENGINE_REQUEST`,
  LOAD_ENGINE_SUCCESS: `${ROOT}LOAD_ENGINE_SUCCESS`,
  LOAD_ENGINE_ERROR: `${ROOT}LOAD_ENGINE_ERROR`,
  LOAD_VERSION_REQUEST: `${ROOT}LOAD_VERSION_REQUEST`,
  LOAD_VERSION_SUCCESS: `${ROOT}LOAD_VERSION_SUCCESS`,
  LOAD_VERSION_ERROR: `${ROOT}LOAD_VERSION_ERROR`,
  DOWNLOAD_TEMPLATE_REQUEST: `${ROOT}DOWNLOAD_TEMPLATE_REQUEST`,
  DOWNLOAD_TEMPLATE_SETTLED: `${ROOT}DOWNLOAD_TEMPLATE_SETTLED`,
  CLEAR_STORE: `${ROOT}CLEAR_STORE`,
} as const;

export default actions;
